var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "emojione-monotone:left-speech-bubble"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.75 4.31888V15.4916C0.75 16.8409 1.85137 17.9355 3.21112 17.9355H14.2987L18.195 22.125V17.9351H20.7892C22.1482 17.9351 23.2504 16.8405 23.2504 15.4913V4.31888C23.25 2.96925 22.1482 1.875 20.7892 1.875H3.21112C1.85137 1.875 0.75 2.96925 0.75 4.31888ZM16.4227 9.90487C16.4227 9.0375 17.1307 8.334 18.0049 8.334C18.879 8.334 19.587 9.0375 19.587 9.90487C19.587 10.773 18.879 11.4761 18.0049 11.4761C17.1307 11.4761 16.4227 10.7734 16.4227 9.90487ZM10.4179 9.90487C10.4179 9.0375 11.1266 8.334 12 8.334C12.8734 8.334 13.5821 9.0375 13.5821 9.90487C13.5821 10.773 12.8734 11.4761 12 11.4761C11.1266 11.4761 10.4179 10.7734 10.4179 9.90487ZM4.41337 9.90487C4.41337 9.0375 5.12212 8.334 5.9955 8.334C6.86962 8.334 7.57762 9.0375 7.57762 9.90487C7.57762 10.773 6.86962 11.4761 5.9955 11.4761C5.12175 11.4765 4.41337 10.7734 4.41337 9.90487Z",
    fill: "#111111"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.643349d5a23fd1eb3eff6c042990f3fc.svg";
export { ForwardRef as ReactComponent };